import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageDocumentTitleContext } from '@/contexts/PageDocumentTitleContext';
import { applyDocumentMetaForRoute } from '@/utils/documentMeta';

/** Syncs tab title and Open Graph / Twitter meta: `頁面 | 香港手球裁判分析系統` */
export default function RouteDocumentTitle() {
  const { pathname, search } = useLocation();
  const titleCtx = usePageDocumentTitleContext();
  const pageLabelOverride = titleCtx?.pageLabel ?? null;

  useLayoutEffect(() => {
    applyDocumentMetaForRoute(pathname, search, pageLabelOverride);
  }, [pathname, search, pageLabelOverride]);

  return null;
}
